import { ButtonType } from 'wix-rich-content-common';

const BUTTONS = ButtonType;

export { BUTTONS };
//# sourceMappingURL=keys.js.map
